import React, { useCallback } from "react";
import styled from "styled-components";

import { primary } from "@formant/ui/component/common/Colors";

import { StandardButton } from "../common/StandardButton";

export function DocumentationButton(props: { url: string }) {
    const { url } = props;
    const openUrl = useCallback(() => {
        window.open(url, "_blank");
    }, []);
    return <Button onClick={openUrl}>Documentation</Button>;
}

const Button = styled(StandardButton)`
    margin-top: 1.25rem;
    margin-left: 1.5rem;
    background: ${primary.steel02};
    width: 19.5rem;
    color: ${primary.silver};
    margin-bottom: 0.5rem;
`;
